<template>
    <listNoveltiesComponent />
</template>

<script>
import listNoveltiesComponent from "@/views/novelties/pages/list_novelties/components/list_novelties_component.vue/"
export default {
    name: "noveltyPage",
    components: {
        listNoveltiesComponent
    },
}
</script>

<style lang="css" scoped>
</style>